// Faux dark-mode browser chrome wrapping a real product screenshot.
export function BrowserFrame({ src, alt, caption, className = "", eager = false }) {
  return (
    <figure className={`overflow-hidden rounded-2xl border border-border/60 bg-[#0B0F19] shadow-2xl shadow-black/40 ${className}`}>
      <div className="flex items-center gap-2 border-b border-border/50 bg-card/70 px-4 py-3">
        <span className="h-3 w-3 rounded-full bg-red-500/70" />
        <span className="h-3 w-3 rounded-full bg-yellow-500/70" />
        <span className="h-3 w-3 rounded-full bg-green-500/70" />
        <span className="ml-3 truncate rounded-md bg-background/60 px-3 py-1 font-mono text-[10px] text-muted-foreground">
          app.semalayer.com
        </span>
      </div>
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : undefined}
        className="block w-full"
      />
      {caption && (
        <figcaption className="border-t border-border/50 bg-card/50 px-4 py-2.5 font-mono text-[11px] text-muted-foreground">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
